module.exports = __webpack_public_path__ + "img/plb4.34fdec60.jpeg";